import {
  getResponsesByQuizId,
  GetResponsesByQuizIdRequestParams,
} from "@/requests/questionnaries/responses-by-quiz-id.request";
import { useQuery } from "@tanstack/react-query";

/**
 * Get all the questions responses in a topic (and dimension)
 */
export const useResponsesByQuizId = (
  params: GetResponsesByQuizIdRequestParams,
  enabled: boolean = true,
) => {
  const queryKey = [
    "companies",
    params.companyId,
    "quiz",
    params.quizId,
    "responses",
    {
      dimension: params.dimension,
      topic: params.topic,
    },
  ];

  return useQuery({
    queryKey: queryKey,
    queryFn: () => getResponsesByQuizId(params),
    enabled:
      !!params.companyId &&
      !!params.quizId &&
      !!params.dimension &&
      !!params.topic &&
      enabled,
  });
};
